import { useEffect, useState } from 'react';

/**
 * useDeferredValue 在 React 17 不可用，这里用 setTimeout 模拟：
 * 输入值快速变化时合并到最后一次；用于把筛选条勾选这类「短时间内多次切换」
 * 推迟到稳定后再触发下游 echarts setOption，避免多张图同步重绘卡主线程。
 *
 * @param value 原始值
 * @param delay 合并窗口（毫秒），默认 80ms（人眼合并阈值附近）
 */
export function useDebouncedValue<T>(value: T, delay = 80): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
